module.exports = __webpack_public_path__ + "static/media/Rain.20a1e3af.mp3";